<script>
    import {colors, gridSize} from '../store';

    let grid = [];
    for (let i = 0; i < gridSize + 1; i++) {
        grid.push({x1: i, x2: i, y1: 0, y2: 10});
        grid.push({x1: 0, x2: 10, y1: i, y2: i});
    }
</script>

<rect x="-.5" y="-.5" width="{gridSize}" height="{gridSize}" fill="{$colors.gray[800]}" />
{#each grid as {x1, x2, y1, y2}}
    <line x1="{x1 - .5}" x2="{x2 - .5}" y1="{y1 - .5}" y2="{y2 - .5}" stroke-width="0.1" stroke="{$colors.gray[900]}" />
{/each}
